import { Theme } from '@mui/material';

export default function Radio(theme: Theme) {
    return {
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: theme.palette.semantic.int.radioButton,
                    padding: '4px',
                    '& .MuiSvgIcon-root': { fontSize: 16 },
                    '&.Mui-checked': {
                        color: theme.palette.semantic.int.radioButton
                    },
                    '&.Mui-disabled': {
                        color: theme.palette.semantic.int.disabled2,
                        backgroundColor: theme.palette.semantic.int.disabled1
                    }
                }
            }
        }
    };
}
